import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
  URL_SITE_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_FOODSTORM = `${URL_RETAILER_SCOPED}/foodstorm`
const URL_FOODSTORM_SITE_SCOPED = `${URL_FOODSTORM}${URL_SITE_SCOPED}`
const URL_FOODSTORM_CREATE_CART = `${URL_FOODSTORM_SITE_SCOPED}/carts/create`
const URL_FOODSTORM_CREATE_CART_REVIEW = `${URL_FOODSTORM_CREATE_CART}/review`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'foodstorm'>
  | DashRouteType<'foodstorm-create-cart'>
  | DashRouteType<'foodstorm-create-cart-review'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  foodstorm: URL_FOODSTORM_SITE_SCOPED,
  'foodstorm-create-cart': URL_FOODSTORM_CREATE_CART,
  'foodstorm-create-cart-review': URL_FOODSTORM_CREATE_CART_REVIEW,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
